<template>
  <div>
    <v-layout row align-center>
      <v-flex>
        <b>{{ notification.name }}</b>
        <p>{{ notification.description }}</p>
        <div>
          Currently
          <span v-if="notification.NotificationSetting">{{
            notification.NotificationSetting.metadata.length
            }}</span>
          <span v-else>0</span> Email(s) set.
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn v-if="notification.NotificationSetting" class="v-btn-with-radius" color="teal" dark
        @click="open(notification)">{{ $t('buttons.edit') }}</v-btn>
      <div v-if="!notification.NotificationSetting">
        <v-btn class="v-btn-with-radius" color="info" @click="open(notification)">{{
          $t('buttons.enable')
          }}</v-btn>
      </div>
      <div v-else>
        <v-btn class="v-btn-with-radius" color="error" @click="disableNotification(notification)">{{
          $t('buttons.disable') }}</v-btn>
      </div>
    </v-layout>
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card class="outlined rounded-border">
        <CardToolbar :title="$t('labels.addEmail')" :isModal="true" @cancel="cancel" />
        <v-container grid-list-md>
          <v-layout row align-center>
            <v-flex xs12 sm4>
              <v-text-field v-model="nameAndEmail.name" solo ref="emailName" :label="$t('labels.name')"
                :error-messages="nameErrors" :hide-details="nameErrors.length === 0"></v-text-field>
            </v-flex>
            <v-flex xs12 sm7>
              <v-text-field v-model="nameAndEmail.email" solo :label="$t('labels.email')" :error-messages="emailErrors"
                :hide-details="emailErrors.length === 0"></v-text-field>
            </v-flex>
            <v-flex shrink>
              <v-btn class="v-btn-with-radius pt-0 mt-0 white--text" color="pink" :disabled="$v.nameAndEmail.$invalid"
                @click="add()">{{ $t('buttons.add') }}</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row align-center v-if="List.length > 0" xs12>
            <v-flex>
              <v-list>
                <div v-for="(row, index) in List">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-btn fab flat @click.stop.prevent="deleted(index)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="row.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="row.email"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < List.length" :key="index"></v-divider>
                </div>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
        <CardActions name="editAlert" @submit="submit" :disabled="List.length === 0 ? true : false" @cancel="cancel" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import locationService from '@/modules/Location/service.js'

const { validationMixin } = require('vuelidate')
const { required, email } = require('vuelidate/lib/validators')

export default {
  props: ['notification', 'LocationId'],
  data() {
    return {
      dialog: false,
      enableNotification: {},
      nameAndEmail: {
        name: null,
        email: null,
      },
      List: [],
    }
  },
  computed: {
    nameErrors() {
      const errors = []
      if (!this.$v.nameAndEmail.name.$dirty) return errors
      if (!this.$v.nameAndEmail.name.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.nameAndEmail.email.$dirty) return errors
      if (!this.$v.nameAndEmail.email.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.nameAndEmail.email.email)
        errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
  },
  methods: {
    async disableNotification() {
      this.$swal
        .fire({
          title: this.$t('messages.title.areYouSure'),
          text: this.$t('messages.text.disableNightlySaleNotification'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#D32F2F',
          cancelButtonColor: '#21BED5',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then(async (result) => {
          if (result.value) {
            await locationService.Settings.Notifications.remove(
              this.LocationId,
              this.notification.NotificationSetting.id,
            )
              .then(() => {
                this.$emit('reload')
                this.$swal.fire(this.$t('messages.title.disabled'), '', 'success')
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    open() {
      this.dialog = true
      this.enableNotification.NotificationSetting = {
        NotificationId: this.notification.id,
        metadata: {},
        ...this.notification.NotificationSetting,
      }
      if (this.notification.NotificationSetting)
        this.List = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata),
        )
    },
    async deleted(index) {
      this.$swal
        .fire({
          title: this.$t('messages.title.areYouSure'),
          text: this.$t('messages.text.youWontBeAbleToRevert'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#D32F2F',
          cancelButtonColor: '#21BED5',
          confirmButtonText: this.$t('buttons.yesDeleteIt'),
        })
        .then((result) => {
          if (result.value) {
            this.List.splice(index, 1)
            this.$swal.fire(
              this.$t('messages.title.deleted'),
              this.$t('messages.text.emailDeleted'),
              'success',
            )
          }
        })
    },

    async submit() {
      console.log('submit buton press')
      if (this.List.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: this.$t('messages.text.addEmailToList'),
          })
        return false
      }
      this.enableNotification.NotificationSetting = {
        ...this.enableNotification.NotificationSetting,
        metadata: this.List,
      }
      console.log('enableNotification', this.enableNotification)
      await locationService.Settings.Notifications.set(
        this.LocationId,
        this.enableNotification.NotificationSetting,
      )
      this.$swal
        .mixin({
          toast: true,
          showConfirmButton: true,
          position: 'top-end',
          timer: 3000,
        })
        .fire({
          icon: 'success',
          title: this.$t('toastMessage.text.updated'),
        })
      this.cancel()
      this.$emit('reload')
    },
    reset() {
      this.nameAndEmail = {
        name: null,
        email: null,
      }
      this.$v.$reset()
      this.$refs.emailName.focus()
    },
    async add() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: this.$t('toastMessage.text.invalidFields'),
          })
        return false
      }

      if (this.List.some((row) => row.email === this.nameAndEmail.email)) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: this.$t('toastMessage.text.emailAlreadyExist'),
          })
        return false
      }

      if (this.List.length >= 5) {
        this.checkEmail = 'can not store more then 5 emails'
      } else {
        this.List.push(this.nameAndEmail)
        this.reset()
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    nameAndEmail: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
}
</script>

<style scoped></style>
